import React from 'react';
import { Typography } from 'material-ui';
import { assets } from '../../../assets';
import { CircularProgress } from '@material-ui/core';

export class AvoidedCO2ConvertedTree extends React.Component {
  render() {
    const {
      classes,
      t,
      avoidedCO2Grams,
      loading,
      co2_per_tree_seedings_in_t,
    } = this.props;

    if (loading) {
      return <CircularProgress size={10} className={classes.buttonProgress} />;
    }

    let totalAvoidedCo2 = avoidedCO2Grams;

    let nbOfTreePlantedConversion = parseInt(
      totalAvoidedCo2 / 1000000 / co2_per_tree_seedings_in_t,
      10
    );

    //1 tree  -> 0.06 Ton of CO2
    //X trees -> totalAvoidedCo2g /1 000 000
    //Source : https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references#seedling

    return (
      <div>
        <div style={{ marginBottom: 20 }}>
          <img
            src={assets.icons.treeIcon}
            alt="tree_icon"
            style={{
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto',
              width: 40,
              height: 40,
            }}
          />
        </div>
        <Typography
          className={classes.title}
          variant="subheading"
          gutterBottom
          align="center"
          color="textSecondary"
          style={{ fontSize: '0.875rem' }}
        >
          <span style={{ fontSize: '1.2rem', color: '#F87733' }}>
            {nbOfTreePlantedConversion}
          </span>
        </Typography>
        <Typography
          className={classes.title}
          variant="subheading"
          gutterBottom
          align="center"
          color="textSecondary"
          style={{ fontSize: '0.875rem' }}
        >
          {t('urban tree seedlings grown for 10 years')}
        </Typography>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/ConvertedAvoidedCO2/AvoidedCO2ConvertedTree.js